<template>
    <div class="sui-icon"
        v-html="icons[name]"
        :style="style"></div>
</template>

<script>
import Mixin from '../../scripts/mixin'

import AddThin from '../../images/icons/add-thin.svg'
import Add from '../../images/icons/add.svg'
import ArrowBack from '../../images/icons/arrow-back.svg'
import ArrowDown from '../../images/icons/arrow-down.svg'
import ArrowDropdown from '../../images/icons/arrow-dropdown.svg'
import ArrowDropleft from '../../images/icons/arrow-dropleft.svg'
import ArrowDropright from '../../images/icons/arrow-dropright.svg'
import ArrowDropup from '../../images/icons/arrow-dropup.svg'
import ArrowForward from '../../images/icons/arrow-forward.svg'
import ArrowUp from '../../images/icons/arrow-up.svg'
import BadOutline from '../../images/icons/bad-outline.svg'
import Bad from '../../images/icons/bad.svg'
import Bookmarks from '../../images/icons/bookmarks.svg'
import Calendar from '../../images/icons/calendar.svg'
import Check from '../../images/icons/check.svg'
import CloseCircle from '../../images/icons/close-circle.svg'
import CloseThin from '../../images/icons/close-thin.svg'
import Close from '../../images/icons/close.svg'
import Edit from '../../images/icons/edit.svg'
import EyeOutline from '../../images/icons/eye-outline.svg'
import FemaleCircle from '../../images/icons/female-circle.svg'
import Female from '../../images/icons/female.svg'
import Fire from '../../images/icons/fire.svg'
import Flag from '../../images/icons/flag.svg'
import FunnelOutline from '../../images/icons/funnel-outline.svg'
import Gift from '../../images/icons/gift.svg'
import GoodOutline from '../../images/icons/good-outline.svg'
import Good from '../../images/icons/good.svg'
import GroupCircle from '../../images/icons/group-circle.svg'
import HappyOutline from '../../images/icons/happy-outline.svg'
import Headset from '../../images/icons/headset.svg'
import History from '../../images/icons/history.svg'
import Home from '../../images/icons/home.svg'
import Letter from '../../images/icons/letter.svg'
import Loading from '../../images/icons/loading.svg'
import MaleCircle from '../../images/icons/male-circle.svg'
import Male from '../../images/icons/male.svg'
import Menu from '../../images/icons/menu.svg'
import MessageOutline from '../../images/icons/message-outline.svg'
import Message from '../../images/icons/message.svg'
import Paper from '../../images/icons/paper.svg'
import PictureOutline from '../../images/icons/picture-outline.svg'
import PinCircle from '../../images/icons/pin-circle.svg'
import PinOutline from '../../images/icons/pin-outline.svg'
import PlayCircleOutline from '../../images/icons/play-circle-outline.svg'
import Play from '../../images/icons/play.svg'
import SadOutline from '../../images/icons/sad-outline.svg'
import Search from '../../images/icons/search.svg'
import Setting from '../../images/icons/setting.svg'
import Sort from '../../images/icons/sort.svg'
import StarOutline from '../../images/icons/star-outline.svg'
import Star from '../../images/icons/star.svg'
import Time from '../../images/icons/time.svg'
import Topic from '../../images/icons/topic.svg'
import Trash from '../../images/icons/trash.svg'

export default {
    name: 'sui-icon',

    mixins: [Mixin],

    props: {

        // 图标名称
        name: {
            type: String,
            required: true
        },

        // 填充颜色，可以是标准色号，也可以是具体颜色值
        fill: [String, Number],
    },

    computed: {
        style() {
            let color = ''
            if (typeof this.fill == 'number') {
                color = this.mColor(this.fill)
            } else {
                color = this.fill ? this.fill : '#000'
            }
            return {
                'fill': color
            }
        }
    },

    data() {
        return {
            icons: {
                'add-thin': AddThin,
                'add': Add,
                'arrow-back': ArrowBack,
                'arrow-down': ArrowDown,
                'arrow-dropdown': ArrowDropdown,
                'arrow-dropleft': ArrowDropleft,
                'arrow-dropright': ArrowDropright,
                'arrow-dropup': ArrowDropup,
                'arrow-forward': ArrowForward,
                'arrow-up': ArrowUp,
                'bad-outline': BadOutline,
                'bad': Bad,
                'bookmarks': Bookmarks,
                'calendar': Calendar,
                'check': Check,
                'close-circle': CloseCircle,
                'close-thin': CloseThin,
                'close': Close,
                'edit': Edit,
                'eye-outline': EyeOutline,
                'female-circle': FemaleCircle,
                'female': Female,
                'fire': Fire,
                'flag': Flag,
                'funnel-outline': FunnelOutline,
                'gift': Gift,
                'good-outline': GoodOutline,
                'good': Good,
                'group-circle': GroupCircle,
                'happy-outline': HappyOutline,
                'headset': Headset,
                'history': History,
                'home': Home,
                'letter': Letter,
                'loading': Loading,
                'male-circle': MaleCircle,
                'male': Male,
                'menu': Menu,
                'message-outline': MessageOutline,
                'message': Message,
                'paper': Paper,
                'picture-outline': PictureOutline,
                'pin-circle': PinCircle,
                'pin-outline': PinOutline,
                'play-circle-outline': PlayCircleOutline,
                'play': Play,
                'sad-outline': SadOutline,
                'search': Search,
                'setting': Setting,
                'sort': Sort,
                'star-outline': StarOutline,
                'star': Star,
                'time': Time,
                'topic': Topic,
                'trash': Trash,
            }
        }
    }
}
</script>

<style lang="postcss">
.sui-icon {
    font-size: 0;
    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
